module.exports = __webpack_public_path__ + "media/components/donate/static/dafdirect-9b454765df0427d65497cb8136120f47.jpg";